module.exports = __webpack_public_path__ + "static/media/java_game_2d.be2a6e05.md";